
import React from "react";
import { Helmet } from "react-helmet";
import Layout from "@/components/layout/Layout";
import { CheckCircle, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function ExpertApplicationThankYouPage() {
  return (
    <Layout>
      <Helmet>
        <title>Application Submitted | Grandpal</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      
      <div className="min-h-[70vh] flex items-center justify-center py-12">
        <div className="container max-w-2xl">
          <Card>
            <CardContent className="p-8 text-center">
              <div className="mb-6 flex justify-center">
                <div className="rounded-full bg-grandpal-green-lighter p-3">
                  <CheckCircle className="h-12 w-12 text-grandpal-green" />
                </div>
              </div>
              
              <h1 className="text-3xl md:text-4xl font-semibold mb-6">
                Application Submitted Successfully!
              </h1>
              
              <p className="text-lg text-grandpal-gray mb-8">
                Thank you for your interest in joining our expert marketplace. 
                We've received your application and will review it carefully.
              </p>
              
              <div className="bg-grandpal-beige/40 rounded-lg p-6 mb-8">
                <h2 className="text-xl font-semibold text-grandpal-green-dark mb-4 flex items-center justify-center gap-2">
                  <Calendar className="h-5 w-5" />
                  Next Step: Book Your Onboarding Interview
                </h2>
                <p className="text-gray-700 mb-6">
                  To complete your application process, please schedule your onboarding interview. 
                  This is a brief 15-20 minute conversation to discuss your expertise and answer any questions.
                </p>
                
                <Button 
                  asChild 
                  size="lg" 
                  className="bg-grandpal-green hover:bg-grandpal-green/90"
                >
                  <a 
                    href="https://calendar.app.google/DWCxRw6TYf7PFNuVA" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <Calendar className="h-4 w-4 mr-2" />
                    Schedule Interview
                  </a>
                </Button>
              </div>
              
              <div className="space-y-4 text-sm text-gray-600">
                <p>
                  <strong>What happens next?</strong>
                </p>
                <ul className="text-left space-y-2 max-w-md mx-auto">
                  <li>• We'll review your application within 2-3 business days</li>
                  <li>• Complete your onboarding interview via the link above</li>
                  <li>• Once approved, you'll receive access to our expert platform</li>
                  <li>• Start helping families and earning on your own schedule</li>
                </ul>
              </div>
              
              <div className="mt-8 pt-6 border-t">
                <Button variant="outline" asChild>
                  <a href="/consultations">Return to Consultations</a>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
}
